// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/common.less' // global css
import './assets/styles/iconfont.css' // global css

import WebStorage from './utils/storage'
import Plugins from './router/plugins'
import {
  getUserMenu
} from './utils/api'
import { MessageBox } from 'element-ui'

//接口地址BASEURL
import link from './utils/link'
// import {MessageBox} from "element-ui/types/index";
window.BASE = link.LINK;

window.LocalStorage = new WebStorage()
router.beforeEach((to, from, next) => {
  if (to.name == 'login') {
    next()
  }else{
    if(!LocalStorage.get('datacollect_token')||!LocalStorage.get('datacollect_userId')){
      next({
        name: 'login'
      })

    }else{
      console.log('beforEach')
      getUserMenu({})
        .then(rs => {
          // self.loading=false;
          if (rs.status == 200) {
            // console.log('getUserMenu')

            if(rs.data&&rs.data.length>0){
              store.commit('SET_Menulist', rs.data);

            }else {
              MessageBox.confirm('获取菜单权限失败，请联系管理员！', '提示', {
                closeOnClickModal:false,
                showClose:false,
                showCancelButton:false,
                confirmButtonText: '确认',
                type: 'warning'
              }).then(() => {

              })
            }

          }
          next()

        })

    }
  }
})
Vue.config.productionTip = false;
Vue.use(ElementUI, { zIndex: 2100 });
Vue.use(Plugins);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js